import type { MovieItem } from "@/mocks/movies";

interface MovieCardProps {
  item: MovieItem;
  showYear?: boolean;
}

export default function MovieCard({ item, showYear = false }: MovieCardProps) {
  return (
    <article className="group flex flex-col">
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 影片海报`}
          title={`${item.title} 在线观看 - 八戒影院`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold">
          {item.genre}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-primary-300 text-xs font-bold flex items-center gap-1">
          <i className="ri-star-fill text-xs" aria-hidden="true" />
          {item.rating}
        </span>
      </div>
      <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-1">
        {item.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 flex items-center gap-2 flex-wrap">
        <span>{item.region}</span>
        {showYear && <span>{item.year}</span>}
        <span className="whitespace-nowrap">{item.genre}</span>
      </p>
    </article>
  );
}